import React from 'react';

export const CanoeIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.612 15.5228C19.6517 13.3546 17.9386 10.9562 15.7704 8.73874L17.7651 6.74401C18.0279 
6.95297 18.352 7.06646 18.6942 7.06646C19.0944 7.06646 19.4697 6.91149 19.7511 6.63008L20.8337 
5.54749C21.4164 4.96473 21.4164 4.01651 20.8337 3.43373L20.5663 3.16632C20.2849 2.88491 19.9095 
2.72992 19.5094 2.72992C19.1093 2.72992 18.7339 2.88491 18.4525 3.16632L17.3699 4.2489C17.0885 4.53031 
16.9336 4.90564 16.9336 5.30578C16.9336 5.64807 17.047 5.97216 17.256 6.23489L15.2612 8.22972C13.5716 
6.57781 11.7666 5.1808 10.023 4.17782C8.20429 3.13161 6.567 2.57861 5.28818 2.57861C4.44025 2.57861 
3.76949 2.81946 3.2945 3.29446C2.3104 4.27855 2.34362 6.11912 3.38804 8.47712C4.3484 10.6454 6.06153 
13.0438 8.2297 15.2612L6.23492 17.256C5.97216 17.047 5.64808 16.9335 5.3058 16.9335C4.90568 16.9335 4.53036 
17.0885 4.24894 17.3699L3.16633 18.4525C2.5836 19.0353 2.5836 19.9835 3.16634 20.5662L3.43379 20.8337C3.71519 
21.1151 4.09053 21.2701 4.49065 21.2701C4.89078 21.2701 5.26612 21.1151 5.54753 20.8337L6.6301 19.7511C6.91151 
19.4697 7.0665 19.0944 7.0665 18.6942C7.0665 18.3519 6.953 18.0279 6.74403 17.7651L8.73891 15.7702C10.4285 
17.4221 12.2335 18.8191 13.9771 19.8221C15.7958 20.8683 17.4331 21.4213 18.7119 21.4213C19.5598 21.4213 20.2306 
21.1805 20.7056 20.7055C21.6897 19.7214 21.6564 17.8808 20.612 15.5228ZM17.8791 4.75802L18.9617 3.67543C19.1071 
3.53 19.3016 3.44991 19.5094 3.44991C19.7172 3.44991 19.9117 3.53 20.0572 3.67544L20.3246 3.94285C20.6266 
4.24489 20.6266 4.73634 20.3246 5.03838L19.242 6.12096C19.0966 6.26637 18.9021 6.34646 18.6942 6.34646C18.4864 
6.34646 18.2919 6.26637 18.1465 6.12097L17.8791 5.85351C17.7336 5.70809 17.6536 5.51357 17.6536 5.30578C17.6536 
5.09797 17.7336 4.90345 17.8791 4.75802ZM4.04635 8.18553C3.24653 6.37974 3.08636 4.91968 3.58142 4.09045L5.66382 
6.17286C5.73412 6.24316 5.82623 6.27831 5.91837 6.27831C6.01049 6.27831 6.10265 6.24315 6.17293 6.17286C6.31352 
6.03227 6.31352 5.80434 6.17293 5.66375L4.08992 3.58073C4.4016 3.39334 4.80292 3.29861 5.28818 3.29861C6.42473 
3.29861 7.97876 3.8325 9.664 4.80193C11.3539 5.77402 13.107 7.1313 14.7521 8.73887L13.2836 10.2074C12.2703 
9.28227 11.1183 8.71848 10.2153 8.71848C9.7674 8.71848 9.39024 8.85889 9.12459 9.12454C8.67801 9.57113 8.59624 
10.2991 8.89433 11.1745C9.1321 11.8727 9.59344 12.6114 10.2074 13.2835L8.73884 14.7521C6.63216 12.5966 4.972 
10.2754 4.04635 8.18553ZM10.7169 12.774C9.52139 11.4559 9.17466 10.0927 9.63372 9.63365C9.76322 9.50415 9.95889 
9.43848 10.2153 9.43848C10.9282 9.43848 11.9058 9.93228 12.7738 10.7171L10.7169 12.774ZM13.2832 11.226C14.4787 
12.5441 14.8254 13.9073 14.3663 14.3663C14.2368 14.4958 14.0412 14.5615 13.7848 14.5615C13.072 14.5615 12.0943 
14.0677 11.2262 13.2829L13.2832 11.226ZM6.12098 19.242L5.03841 20.3246C4.89299 20.47 4.69846 20.5501 4.49065 
20.5501C4.28284 20.5501 4.08831 20.47 3.94289 20.3246L3.67544 20.0571C3.37342 19.7551 3.37344 19.2637 3.67544 
18.9616L4.75805 17.879C4.90347 17.7336 5.098 17.6535 5.3058 17.6535C5.51359 17.6535 5.70812 17.7336 5.85357 
17.8791L6.12098 18.1465C6.26641 18.2919 6.3465 18.4864 6.3465 18.6942C6.3465 18.902 6.26642 19.0965 6.12098 
19.242ZM14.3361 19.198C12.6462 18.2259 10.8931 16.8686 9.24804 15.2611L10.7165 13.7926C11.7298 14.7177 12.8818 
15.2815 13.7848 15.2815C14.2327 15.2815 14.6098 15.1411 14.8755 14.8754C15.322 14.4289 15.4038 13.7008 15.1057 
12.8255C14.8679 12.1273 14.4066 11.3886 13.7926 10.7165L15.2612 9.24788C17.3679 11.4034 19.0281 13.7246 19.9537 
15.8144C20.7535 17.6202 20.9137 19.0802 20.4186 19.9095L18.3362 17.8271C18.1956 17.6865 17.9677 17.6865 17.8271 
17.8271C17.6866 17.9677 17.6866 18.1956 17.8271 18.3362L19.9101 20.4192C19.5985 20.6066 19.1971 20.7013 18.7119 
20.7013C17.5753 20.7013 16.0213 20.1674 14.3361 19.198Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
